import React, { useEffect } from 'react';
import Product from '../../Types/Product';
import ProductCardLandscape from '../ProductCards/ProductCardLandscape';
import { useTypedSelector } from '../../Hooks/useTypedSelector';
import { useDispatch } from 'react-redux';
import { setNavisionListingPricesWithPlaceholdersByIds } from '../../Actions/NavisionPrices.action';
import { setNavisionListingstocksWithPlaceholders, setNavisionListingstocksFromIds } from '../../Actions/NavisionStock.action';

interface ProductPageVariantListProps {
  variants: Product[];
}

const ProductPageVariantList = ({
  variants,
}: ProductPageVariantListProps) => {
  const dispatch = useDispatch();

  const { isInBuyableState } = useTypedSelector((state) => state.buyableState);
  const { navisionStocks } = useTypedSelector((state) => state.productListing);  

  useEffect(() => {
    if (isInBuyableState) {
      dispatch(setNavisionListingPricesWithPlaceholdersByIds(variants));
      dispatch(setNavisionListingstocksWithPlaceholders());
    }
  }, [])

  useEffect(() => {
    dispatch(setNavisionListingstocksFromIds(variants.map(p => p.id)));
  }, [])

  return (
    <div className="mt-4 grid grid-cols-1 gap-2 md:mt-4">
      {variants.map((p) => (
        <ProductCardLandscape
          product={p}
          navisionStock={navisionStocks?.find(x => x.productId == p.id)}
          isVariantListing={true}
          key={'ProductPageVariantList' + p.id}
          isInBuyableState={isInBuyableState}
        />
      ))}
    </div>
  );
};

export default ProductPageVariantList;
